__turbopack_context__.v({
  "container": "LandingBackground-module-scss-module__9fWrfG__container",
});
